import { NotificationViewModel } from 'src/models/notification-view-model';
import {
  NotificationRecipientRecord,
  NotificationRecipientViewModelBase,
} from 'src/store/generated/notification-recipient-record.generated';

export class NotificationRecipientViewModel extends NotificationRecipientViewModelBase {
  constructor(
    notificationRecipient: NotificationRecipientRecord,
    public readonly notification: NotificationViewModel,
  ) {
    super(notificationRecipient);
  }
}
